import { render, staticRenderFns } from "./ConferenceEventPage.vue?vue&type=template&id=1ce595e1&scoped=true"
import script from "./ConferenceEventPage.vue?vue&type=script&lang=js"
export * from "./ConferenceEventPage.vue?vue&type=script&lang=js"
import style0 from "./ConferenceEventPage.vue?vue&type=style&index=0&id=1ce595e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.39_css-loader@6.11.0_webpack@5.108.4_clean-css_8f79fb19793044b4215c482fdb8be9e8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce595e1",
  null
  
)

export default component.exports